// extracted by mini-css-extract-plugin
export default {"headerSolicitudes":"TablaProducto_headerSolicitudes__pnw61","text_danger":"TablaProducto_text_danger__iC-cL","text_success":"TablaProducto_text_success__ENfwT"};